import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { fetchPostageAccountDetails, updatePostageAccount } from '../services/api';
import { useUser } from '../context/UserContext';
import { Form } from 'react-bootstrap';

function PostageAccountEdit() {
    const { postageAccountNumber } = useParams();
    const navigate = useNavigate();
    const { user } = useUser();
    const [account, setAccount] = useState({
        department: '',
        worktagString: '',
        worktagChangeRequest: '',
        comments: '',
        activeStatus: true
    });
    const [error, setError] = useState('');
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isOwner, setIsOwner] = useState(false);
    const [loading, setLoading] = useState(true);

    //console.log(user);

    useEffect(() => {
        if (user && user.netId && user.accountLevel) {
            fetchPostageAccountDetails(postageAccountNumber)
                .then(data => {
                    setAccount({ ...data, worktagString: data.worktagString }); // Convert array to string
                    setIsAuthorized(user.accountLevel == 2 || user.netId == data.owner.netId);
                    console.log(user.accountLevel);
                    setLoading(false);
                })
                .catch(error => {
                    console.error('Failed to fetch account details:', error);
                    setError('Failed to fetch account details');
                    setLoading(false);
                });
        } else {
            setLoading(false); // Ensure that loading state is resolved if user context isn't loaded yet
        }
    }, [postageAccountNumber, user]);
    console.log("is authorized is " + isAuthorized);
    if (loading) {
        return (<div>Loading...</div>);
    }

    if (!isAuthorized && !loading) {
        return (<Navigate to="/unauthorized" />);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setAccount(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const updateData = {
                ...account,
                worktagString: account.worktagString // Convert string back to array
            };
            await updatePostageAccount(postageAccountNumber, updateData);
            navigate(`/postage-account/${postageAccountNumber}`);
        } catch (error) {
            console.error('Failed to update account:', error);
            setError('Failed to update account: ' + error.message);
        }
    };

    return (
        <div className="container mt-3">
            <h1>Edit Postage Account: {postageAccountNumber}</h1>
            {error && <div className="alert alert-danger" role="alert">{error}</div>}
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="worktagString" className="form-label">Worktag String</label>
                    <input type="text" className="form-control" id="worktagString" name="worktagString" value={account.worktagString} onChange={handleChange} />
                </div>
                <div className="mb-3">
                    <Form.Label><b>Postage Account Comments</b></Form.Label>
                    <Form.Control as="textarea" rows={8} id="comments" name="comments" value={account.comments} onChange={handleChange} />
                </div>
                <button type="submit" className="btn btn-primary">Update</button>
            </form>
        </div>
    );
}

export default PostageAccountEdit;
